// import "../../../assets/scss/Loader.scss";
import PropTypes from "prop-types";

const Loader = ({ className }) => {
  return (
    <>
      <div translate="no" className={`pgLdr ${className}`}>
        <div className="pgLdrIg mb-3">
          <img
            src={require("../../../assets/images/logo.png")}
            alt="logo"
            width={200}
          />
        </div>
        <div className="pgLdrTx">Quantara Loading...</div>
      </div>

      <svg style={{ position: "absolute", width: "0px", height: "0px" }}>
        <filter id="white-border">
          <feMorphology
            in="SourceAlpha"
            result="expanded"
            operator="dilate"
            radius="1"
          />
          <feFlood floodColor="white" result="white-fill" />
          <feComposite
            in="white-fill"
            in2="expanded"
            operator="in"
            result="outline"
          />

          <feMerge>
            <feMergeNode in="outline" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </svg>
    </>
  );
};
Loader.propTypes = {
  className: PropTypes.any,
};
export default Loader;
